// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604070833/js/" + chunkId + "." + {"44":"c3c07b6c","225":"b3d0e226","481":"5336f73d","486":"0eac4a1f","770":"81e47274"}[chunkId] + ".0.17841140898658625.chunk.js";
};